import {IMAGES_URL} from '@cdn';
import {useOverallInfo} from '@components/_context';
import {useSiteSegments} from '@components/_context/UserOverallInfo/_hooks/useSiteSegments';
import {useDevice} from '@lookiero/aurora';

interface UseRafImagePaths {
  src: string;
  srcSet: string;
}
type Image = 'banner-info' | 'banner-share' | 'referral';

export const useRafImagePath = (image: Image): UseRafImagePaths => {
  const {screen} = useDevice();
  const {isMultiSegment} = useSiteSegments();
  const {segment} = useOverallInfo();
  const pathSegment = isMultiSegment() ? 'neutral' : segment.toLocaleLowerCase();

  return {
    src: `${IMAGES_URL()}/raf/${image}/v2/${pathSegment}/${image}@${screen.L ? 3 : screen.M ? 2 : 1}x.jpg`,
    srcSet: [1, 2, 3]
      .map(current => `${IMAGES_URL()}/raf/${image}/v2/${pathSegment}/${image}@${current}x.jpg ${current}x`)
      .join(', '),
  };
};
